export enum UserRole {
  TEACHER,
  PARENT,
  CARREER_ADVISOR,
}

export enum UserRbacRole {
  ADMIN = 'admin',
  ROTTAL_INN = 'rottal-inn',
}
